import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SubscribedComponent } from '../../subscribed.component';
import { AuthService } from '../../shared/auth.service';
import { RegistrationWeekService } from '../registration-week.service';
import { Globals } from '../../shared/Globals';
import { TrackUserResult } from '../../interfaces/user';
import { WeekTripsComponent } from '../../timesheet/week-trips/week-trips.component';

@Component({
  selector: 'bst-kilometres',
  templateUrl: './kilometres.component.html',
  styleUrls: ['./kilometres.component.scss'],
  standalone: false,
})
export class KilometresComponent extends SubscribedComponent implements OnInit, OnDestroy {
  @ViewChild(WeekTripsComponent) trips?: WeekTripsComponent;

  constructor(public week: RegistrationWeekService, private auth: AuthService) { super(); }

  get canOthers(): boolean { return this.auth.isAdmin || this.auth.isStaffer; }

  async ngOnInit() {
    this.subs.push(this.week.user.valueChanges.subscribe(() => this.reload()));
    await this.reload();
  }

  async page(step: number) {
    this.week.date = this.week.date.clone().startOf('isoWeek').add(step, 'week');
    await this.reload();
  }

  // An open trip row locks the person picker; switching people would drop it (spec 2026-10-13).
  // It holds Submit back too.
  lockPerson(editing: boolean) {
    this.week.editing = editing;
    editing ? this.week.user.disable({emitEvent: false}) : this.week.user.enable({emitEvent: false});
  }

  // Safety net: the widget's own destroy emits editing(false) first; this keeps Submit free if that ever changes.
  ngOnDestroy() {
    super.ngOnDestroy();
    this.lockPerson(false);
  }

  // The route's canDeactivate (app-routing): a changed open trip row asks first.
  canLeave(): Promise<boolean> {
    return this.trips?.canLeave() ?? Promise.resolve(true);
  }

  async reload() {
    // Don't zero tripRows here (M3): a no-op submit or a reload with an unchanged
    // week/user never flips bst-week-trips' inputs, so it never re-emits tripCount,
    // and Submit would stay disabled on a trips-only week until navigation.
    this.loading.next(true);
    this.week.beginLoad();
    try { await this.week.load(); } finally { this.loading.next(false); this.week.endLoad(); }
  }

  // Same as TimesheetComponent.logo (timesheet.component.ts 1372-1374).
  logo(user: TrackUserResult) {
    return user.logo && user.logo.preview ? Globals.storage(user.logo.preview) : user.provider_avatar;
  }

  public get headerTitle() { return {title: 'registration.km', translate: true}; }
}
